package com.solevo.dist.util

import com.solevo.dist.application.models.DocMetadata
import dev.gitlive.firebase.Firebase
import dev.gitlive.firebase.storage.storage

object StorageUrlResolver {

    suspend fun resolveDocUrl(docMetadata: DocMetadata?): String? {
        val url = docMetadata?.url
        if (!url.isNullOrBlank()) return url

        val filePath = docMetadata?.filePath
        if (filePath.isNullOrBlank()) return null

        return try {
            Firebase.storage.reference(filePath).getDownloadUrl()
        } catch (_: Exception) {
            null
        }
    }
}
